import type { PropsWithChildren } from "react";
import { useMemo } from "react";
import useIsMobile from "../../hooks/device/useIsMobile";
import { BaseLayoutV2Adjustable } from "./BaseLayoutV2Adjustable";

export interface IBaseLayoutV2Props {
  readonly header: React.ReactNode;
}

enum BaseLayoutV2Width {
  mobile = "100%",
  desktop = "74rem",
}

export function BaseLayoutV2({ children, header }: PropsWithChildren<IBaseLayoutV2Props>): JSX.Element {
  const isMobile = useIsMobile();

  const bodyWidth = useMemo(
    function getBodyWidth() {
      return isMobile ? BaseLayoutV2Width.mobile : BaseLayoutV2Width.desktop;
    },
    [isMobile]
  );

  return (
    <BaseLayoutV2Adjustable header={header} bodyWidth={bodyWidth}>
      {children}
    </BaseLayoutV2Adjustable>
  );
}
